// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as LumiJzon from "./LumiJzon.res.js";
import * as Stdlib_Date from "@rescript/runtime/lib/es6/Stdlib_Date.js";
import * as StringCodec from "./StringCodec.res.js";
import Add from "date-fns/add";
import Sub from "date-fns/sub";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Stdlib_Ordering from "@rescript/runtime/lib/es6/Stdlib_Ordering.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import SubDays from "date-fns/subDays";
import SubYears from "date-fns/subYears";
import SubMonths from "date-fns/subMonths";
import AddMilliseconds from "date-fns/addMilliseconds";
import DifferenceInSeconds from "date-fns/differenceInSeconds";

function since(date) {
  return Date.now() - date.getTime();
}

function dateWireFormat(date) {
  return date.toISOString().substring(0, 10);
}

function cmp(a, b) {
  return Stdlib_Date.compare(a, b) | 0;
}

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

function toString(date) {
  return date.toISOString().substring(0, 10);
}

function fromString(str) {
  let date = new Date(str);
  if (Number.isNaN(date.getTime())) {
    return {
      TAG: "Error",
      _0: "Invalid date: " + str
    };
  } else {
    return {
      TAG: "Ok",
      _0: date
    };
  }
}

function stringCodec_fromString(str) {
  return Stdlib_Result.mapOr(fromString(str), undefined, v => v);
}

let stringCodec = {
  toString: toString,
  fromString: stringCodec_fromString
};

let jsonCodec = LumiJzon.stringCodec(stringCodec);

function copy(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

let $$Date$1 = {
  toString: toString,
  fromString: fromString,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec,
  copy: copy
};

let Private = {
  $$Date: $$Date$1
};

function toString$1(prim) {
  return prim.toISOString();
}

function fromString$1(str) {
  let date = new Date(str);
  if (Number.isNaN(date.getTime())) {
    return {
      TAG: "Error",
      _0: "Invalid date: " + str
    };
  } else {
    return {
      TAG: "Ok",
      _0: date
    };
  }
}

function stringCodec_fromString$1(str) {
  return Stdlib_Result.mapOr(fromString$1(str), undefined, v => v);
}

let stringCodec$1 = {
  toString: toString$1,
  fromString: stringCodec_fromString$1
};

let jsonCodec$1 = LumiJzon.stringCodec(stringCodec$1);

let DateTime = {
  toString: toString$1,
  fromString: fromString$1,
  stringCodec: stringCodec$1,
  jsonCodec: jsonCodec$1
};

function first(dates) {
  if (dates.length !== 0) {
    return new Date(Math.min(...dates.map(prim => prim.getTime())));
  }
}

function last(dates) {
  if (dates.length !== 0) {
    return new Date(Math.max(...dates.map(prim => prim.getTime())));
  }
}

function toSeconds(duration) {
  if (duration.TAG === "Seconds") {
    return duration._0;
  } else {
    return duration._0 / 1e6;
  }
}

function fromSeconds(s) {
  return {
    TAG: "Seconds",
    _0: s
  };
}

function toMicroseconds(duration) {
  if (duration.TAG === "Seconds") {
    return duration._0 * 1e6;
  } else {
    return duration._0;
  }
}

function fromMicroseconds(us) {
  return {
    TAG: "Microseconds",
    _0: us
  };
}

let seconds = Jzon.custom(duration => Jzon.encodeWith(toSeconds(duration), Jzon.float), json => Stdlib_Result.map(Jzon.decodeWith(json, Jzon.float), fromSeconds));

let microseconds = Jzon.custom(duration => Jzon.encodeWith(toMicroseconds(duration), Jzon.float), json => Stdlib_Result.map(Jzon.decodeWith(json, Jzon.float), fromMicroseconds));

let JsonCodecs = {
  seconds: seconds,
  microseconds: microseconds
};

let Duration = {
  toSeconds: toSeconds,
  fromSeconds: fromSeconds,
  toMicroseconds: toMicroseconds,
  fromMicroseconds: fromMicroseconds,
  JsonCodecs: JsonCodecs
};

function toDate(date) {
  return date;
}

function unsafeFromDate(date) {
  return date;
}

function fromDateNoCopy(date) {
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function fromDate(date) {
  return fromDateNoCopy(copy(date));
}

function mapDate(day, f) {
  return f(day);
}

function make() {
  return fromDateNoCopy(new Date());
}

function makeWithYMD(year, month, day) {
  return fromDateNoCopy(new Date(year, month, day));
}

let stringCodec$2 = StringCodec.iso(stringCodec, unsafeFromDate, toDate);

let jsonCodec$2 = LumiJzon.stringCodec(stringCodec$2);

function subDays(day, days) {
  return SubDays(day, days);
}

let Day_toString = stringCodec$2.toString;

let Day_fromString = stringCodec$2.fromString;

let Day = {
  toDate: toDate,
  unsafeFromDate: unsafeFromDate,
  fromDateNoCopy: fromDateNoCopy,
  fromDate: fromDate,
  mapDate: mapDate,
  make: make,
  makeWithYMD: makeWithYMD,
  stringCodec: stringCodec$2,
  toString: Day_toString,
  fromString: Day_fromString,
  jsonCodec: jsonCodec$2,
  subDays: subDays
};

function fromDate$1(date) {
  return date;
}

function toDate$1(date) {
  return date;
}

function fromMilliSecondsSinceEpoch(msSinceEpoch) {
  return new Date(msSinceEpoch);
}

function fromSecondsSinceEpoch(sSinceEpoch) {
  return new Date(1000 * sSinceEpoch);
}

function make$1() {
  return new Date();
}

let copy$1 = copy;

let compare = Stdlib_Date.compare;

function isBefore(a, b) {
  return Stdlib_Ordering.isLess(Stdlib_Date.compare(a, b));
}

function isBeforeOrSame(a, b) {
  return !Stdlib_Ordering.isGreater(Stdlib_Date.compare(a, b));
}

function isAfter(a, b) {
  return Stdlib_Ordering.isGreater(Stdlib_Date.compare(a, b));
}

function isAfterOrSame(a, b) {
  return !Stdlib_Ordering.isLess(Stdlib_Date.compare(a, b));
}

function min(a, b) {
  if (Stdlib_Ordering.isLess(Stdlib_Date.compare(a, b))) {
    return a;
  } else {
    return b;
  }
}

function differenceInSeconds(a, b) {
  return DifferenceInSeconds(a, b);
}

function getFullYear(date) {
  return date.getUTCFullYear();
}

function getMonth(date) {
  return date.getUTCMonth();
}

function sameYear(x, y) {
  let xYear = x.getUTCFullYear();
  let yYear = y.getUTCFullYear();
  return xYear === yYear;
}

function sameMonth(x, y) {
  let xMonth = x.getUTCMonth();
  let yMonth = y.getUTCMonth();
  if (xMonth === yMonth) {
    return sameYear(x, y);
  } else {
    return false;
  }
}

function showMonth(month) {
  return month.getUTCFullYear().toString() + "-" + (month.getUTCMonth() + 1 | 0).toString();
}

function showYear(year) {
  return year.getUTCFullYear().toString();
}

function addMilliseconds(date, ms) {
  return AddMilliseconds(date, ms);
}

function addHours(date, hours) {
  let duration_hours = hours;
  let duration = {
    hours: duration_hours
  };
  return Add(date, duration);
}

function subHours(date, hours) {
  let duration_hours = hours;
  let duration = {
    hours: duration_hours
  };
  return Sub(date, duration);
}

function subMonths(date, months) {
  return SubMonths(date, months);
}

function subYears(date, years) {
  return SubYears(date, years);
}

function setMonth(date, m) {
  date.setUTCMonth(m);
}

function setDate(date, d) {
  date.setUTCDate(d);
}

function setHoursMSMs(date, hours, minutes, seconds, milliseconds) {
  date.setUTCHours(hours, minutes, seconds, milliseconds);
}

function startOfMonth(date) {
  let _date = copy(date);
  setDate(_date, 1);
  setHoursMSMs(_date, 0, 0, 0, 0);
  return _date;
}

function startOfYear(date) {
  let _date = copy(date);
  setMonth(_date, 0);
  setDate(_date, 1);
  setHoursMSMs(_date, 0, 0, 0, 0);
  return _date;
}

let stringCodec$3 = StringCodec.iso(stringCodec$1, fromDate$1, toDate$1);

let jsonCodec$3 = LumiJzon.stringCodec(stringCodec$3);

let UTCDate_toString = stringCodec$3.toString;

let UTCDate_fromString = stringCodec$3.fromString;

let UTCDate = {
  fromDate: fromDate$1,
  toDate: toDate$1,
  fromMilliSecondsSinceEpoch: fromMilliSecondsSinceEpoch,
  fromSecondsSinceEpoch: fromSecondsSinceEpoch,
  make: make$1,
  copy: copy$1,
  compare: compare,
  isBefore: isBefore,
  isBeforeOrSame: isBeforeOrSame,
  isAfter: isAfter,
  isAfterOrSame: isAfterOrSame,
  min: min,
  differenceInSeconds: differenceInSeconds,
  getFullYear: getFullYear,
  getMonth: getMonth,
  sameYear: sameYear,
  sameMonth: sameMonth,
  showMonth: showMonth,
  showYear: showYear,
  addMilliseconds: addMilliseconds,
  addHours: addHours,
  subHours: subHours,
  subMonths: subMonths,
  subYears: subYears,
  setMonth: setMonth,
  setDate: setDate,
  setHoursMSMs: setHoursMSMs,
  startOfMonth: startOfMonth,
  startOfYear: startOfYear,
  stringCodec: stringCodec$3,
  toString: UTCDate_toString,
  fromString: UTCDate_fromString,
  jsonCodec: jsonCodec$3
};

function atTime(x, time) {
  return Stdlib_Option.map(x.toReversed().find(param => Primitive_object.lessequal(param[0], time)), prim => prim[1]);
}

let DatesWith = {
  atTime: atTime
};

let $$Date$2;

export {
  since,
  dateWireFormat,
  Cmp,
  Private,
  DateTime,
  first,
  last,
  Duration,
  Day,
  UTCDate,
  DatesWith,
  $$Date$2 as $$Date,
}
/* Cmp Not a pure module */
